import { useBackendApi } from './backendApi';
import { useEventsSubscriber } from 'event-bus';
import { useCacheService } from './cacheService';
import { ProjectType } from './Types';
import { FUB_PIPELINES_MAPPING_UPDATED } from './fubPipelineMappingService';

export interface FubStage {
  id: number;
  name: string;
}

export const FUB_STAGES_UPDATED = 'FUB_STAGES_UPDATED';

export const FUB_STAGES_CACHE_KEY = 'fubStages';

export function useFubStagesService() {
  const nekstApi = useBackendApi();
  const cacheService = useCacheService('fubStagesService');

  const cacheKeys: Record<string, true> = {};

  const clearCache = () => {
    cacheService.clearByPrefix(FUB_STAGES_CACHE_KEY);
  }

  useEventsSubscriber('fubStagesService', {
    [FUB_STAGES_UPDATED]: () => {
      clearCache();
    },
    [FUB_PIPELINES_MAPPING_UPDATED]: () => {
      clearCache();
    }
  }, []);

  const getAllStages = async (
    profileId: number,
    projectType: ProjectType
  ): Promise<FubStage[]> => {
    const cacheKey = `${FUB_STAGES_CACHE_KEY}_${profileId}_${projectType}`;

    return cacheService.get(cacheKey, async (cacheItem) => {
      cacheItem.setExpireInSeconds(60);
      cacheKeys[cacheKey] = true;

      return await nekstApi.get(`/integrations/profiles/${profileId}/fubstages/${projectType.toLowerCase()}`) as FubStage[];
    });
  };

  return {
    getAllStages,
  };
}
